module.exports = __webpack_public_path__ + "img/logo2.f7df21d7.svg";